import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ODSText } from '../ODSText';
import { getTokens } from '../../../design-tokens/color-tokens';

interface ODSIndicatorProps {
    completed: number;
    size?: number;
    color?: string;
    label?: string;
}

const ODSIndicator = ({
    completed,
    size = 5,
    color,
    label
}: ODSIndicatorProps) => {
    const colors = (getTokens('light').colors as any);
    const themeColor = color || colors.theme.blue;
    const inactiveColor = colors.neutral[300];

    const segments = [];
    for (let i = 1; i <= size; i++) {
        segments.push(
            <View
                key={i}
                style={[
                    styles.segment,
                    {
                        backgroundColor: i <= completed ? themeColor : inactiveColor,
                    }
                ]}
            />
        );
    }

    return (
        <View style={styles.container}>
            <View style={styles.segmentsContainer}>
                {segments}
            </View>
            {label ? (
                <ODSText
                    type="md"
                    color={colors.text.grey}
                    marginTop={12}
                    style={styles.label}
                    textAlign='center'
                >
                    {label}
                </ODSText>
            ) : null}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: '100%',
        alignItems: 'center',
    },
    segmentsContainer: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    segment: {
        flex: 1,
        height: 12,
        borderRadius: 6,
        marginHorizontal: 4,
    },
    label: {
        textAlign: 'center',
    }
});

export default ODSIndicator;
